// extracted by mini-css-extract-plugin
export default {"app-container":"App_app-container__Vu1GH","nav":"App_nav__Yz+gE","main":"App_main__nhgh3","footer":"App_footer__aawhi","footer-text":"App_footer-text__I8CCt"};